import axiosInstance from 'api/axiosConfig'
import { ENDPOINTS } from 'api/endpoints'
import handleApiError from 'api/utils/handleApiError'

const useUploadImageService = () => {

  const uploadImage = async (formData: FormData): Promise<any> => {
    try {
      // Uploads can exceed the global 10s axios timeout (esp. multiple photos).
      const response = await axiosInstance.post(
        ENDPOINTS.FILE.UPLOAD_IMAGE,
        formData,
        { timeout: 120000 }
      )

      if (!response.data) {
        throw new Error()
      }

      return response.data
    } catch (err) {
      handleApiError('Failed to upload images', err)
    }
  }

  return {
    uploadImage,
  }
}

export default useUploadImageService
